export default __webpack_public_path__ + "static/media/application-screenshots-06.a75ff851.jpg";